// Copyright (c) Docugami, Inc. All rights reserved.

import axios from "axios";
import { useEffect } from "react"
import { isNetworkError } from "utils/errorUtils";
import { useAppDispatch } from "./redux";
import { addNetworkError } from "store/errorSlice";

export const useNetworkErrorTracker = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const onError = (error: any) => {
            if (isNetworkError(error)) {
                dispatch(addNetworkError());
            }
        }

        const unsubscribe = axios.interceptors.response.use(undefined, onError);
        return () => {
            axios.interceptors.response.eject(unsubscribe);
        }
    }, [dispatch])
}